module.exports = __webpack_public_path__ + "static/cosygiraffemustard-8cc9aece69ae7408d41ccf1e52d7d7c3.jpeg";